import MessagePadrao from "./MessagePadrao";
import * as Sentry from "@sentry/react";

function MessageApiErrors({ erro }) {
  const renderMessage = (erro) => {
    let mensagemRetorno = null;
    let level = "error";
    if (erro?.response?.status === 422) {
      let mensagens = erro.response.data?.contexto;
      if (!mensagens) {
        if (erro.response.data?.mensagem) {
          return erro.response.data?.mensagem;
        } 
        return "Ocorreu um erro ao validar os dados. Tente novamente.";
      }

      let retorno = [];
      Object.keys(mensagens).forEach((campo) => {
        Object.keys(mensagens[campo]).forEach((tipoErro) => {
          retorno.push(mensagens[campo][tipoErro]);
        });
      });
      mensagemRetorno = retorno.join(", ");
      level = "warning";
    }
    else if (erro?.response?.status >= 400 && erro?.response?.status < 500) {
      mensagemRetorno = erro.response.data?.mensagem;
    }
    else {
      mensagemRetorno = "Ocorreu um erro interno. Tente novamente.";
    }

    Sentry.captureMessage(mensagemRetorno, {
      extra: {
        request: erro.config,
        data: erro.data,
        message: mensagemRetorno,
      },
      level: level,
    });

    return mensagemRetorno;
  };

  return (
    <MessagePadrao content={renderMessage(erro)} />
  );
}

export default MessageApiErrors;
